import { KVERNELAND_COLORS } from '../themeConf';
export const sentryReportStyle = {
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]': {
        backgroundColor: `${KVERNELAND_COLORS.success.main} !important`,
        border: 'none !important',
        outline: 'none !important',
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:hover': {
        backgroundColor: `${KVERNELAND_COLORS.success.dark} !important`,
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:active': {
        backgroundColor: `${KVERNELAND_COLORS.success.main} !important`,
    },
};
//# sourceMappingURL=sentryReportStyle.js.map